'use client';
import { useEffect, useRef } from 'react';
import { CatIconWarningCircle } from 'blocks-nextjs/blocks-react/components/Icons/WarningCircle';
import { ErrorBanner } from 'components/pcc-components';
import { useEsiteCtx } from 'services/esite/context';
import { normalizeUrl } from 'utils/url';
import { CONTACT_US_DEALER } from 'constants/endpoints';
import { replaceTokensInString } from '@cat-ecom/common/utils/stringUtils';
import cx from 'classnames';

type ErrorBannerMessageProps = {
  bannerLabel: string;
  buttonLabel: string;
  className?: string;
};

export const ErrorBannerMessage = ({
  bannerLabel,
  buttonLabel,
  className
}: ErrorBannerMessageProps) => {
  const { catalogId, langId, storeId } = useEsiteCtx();
  const errorRef = useRef(null);
  const contactUsUrl =
    catalogId && storeId && langId
      ? normalizeUrl(
          replaceTokensInString(
            `${CONTACT_US_DEALER}`,
            catalogId,
            langId,
            storeId
          )
        )
      : undefined;

  useEffect(() => {
    const savedTabIndex = errorRef.current.getAttribute('tabIndex');
    errorRef.current.setAttribute('tabIndex', -1);
    errorRef.current?.focus();
    errorRef.current.setAttribute('tabIndex', savedTabIndex);
  }, []);

  return (
    <div
      data-testid="error-banner-banner-message"
      ref={errorRef}
      className={cx(className, 'mb-5')}
    >
      <ErrorBanner
        heading={bannerLabel}
        variant="error"
        buttonProp={{
          buttonText: buttonLabel,
          className: 'text-nowrap ot-sdk-show-settings',
          slot: 'after',
          type: 'button',
          href: contactUsUrl
        }}
      >
        <CatIconWarningCircle slot="before" />
      </ErrorBanner>
    </div>
  );
};
